'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    this.getWaveforms();
  }

  getWaveforms() {
    this.$http.get('/api/waveforms').then(res => {
      this.waveforms = res.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete(`/api/waveforms/${id}`).then(res => {
        this.getWaveforms();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/waveforms/list/list.controller.js